import axios from 'axios';
import type { Channel, ChannelPaymentMethod, ChannelPaymentMethods } from '../model';

// router-ручки отдают тело либо как есть, либо завернутым в { data }
function unwrap<T>(body: any): T {
  return body !== null && typeof body === 'object' && 'data' in body ? body.data : body;
}

export class ChannelApi {
  static readonly KEY = 'channel';

  static async getChannels(): Promise<Channel[]> {
    const { data } = await axios.get('/api/router/v1/channel');
    const channels = unwrap<Channel[]>(data);

    if (!Array.isArray(channels)) {
      console.error('Unexpected /api/router/v1/channel response', data);

      return [];
    }

    return channels;
  }

  static async getChannelById(id: number): Promise<Channel> {
    const { data } = await axios.get(`/api/router/v1/channel/${id}`);

    return unwrap<Channel>(data);
  }

  static async toggleChannel(id: number): Promise<void> {
    await axios.patch(`/api/router/v1/channel/${id}`);
  }

  static async getPaymentMethods(): Promise<ChannelPaymentMethods> {
    const { data } = await axios.get('/api/router/v1/paymentMethod');
    const paymentMethods = unwrap<ChannelPaymentMethods>(data);

    if (paymentMethods === null || typeof paymentMethods !== 'object') {
      console.error('Unexpected /api/router/v1/paymentMethod response', data);

      return {};
    }

    return paymentMethods;
  }

  static async getPaymentMethodById(id: number): Promise<ChannelPaymentMethod> {
    const { data } = await axios.get(`/api/router/v1/paymentMethod/${id}`);

    return unwrap<ChannelPaymentMethod>(data);
  }

  static async togglePaymentMethod(id: number): Promise<void> {
    await axios.patch(`/api/router/v1/paymentMethod/${id}`);
  }
}
